export default {
  catalog: {
    pageTitle: "Catalogue",
    subtitle: "Search the whole CIMA catalogue and add products to your portfolio or competitors",
    searchPlaceholder: "Search by name, CN, active substance or laboratory…",
    prompt: "Type at least 2 characters to search the CIMA catalogue.",
    loading: "Searching…",
    noResults: "No results in the catalogue.",
    colProduct: "Product",
    colActiveIngredient: "Active substance",
    colLaboratory: "Laboratory",
    colStatus: "Status",
    marketed: "Marketed",
    notMarketed: "Not marketed",
    inPortfolio: "In My Products",
    inCompetitors: "In Competitors",
    viewSheet: "View sheet",
    addToPortfolio: "Add to My Products",
    addToCompetitors: "Add to Competitors",
    addedPortfolio: "Added to My Products",
    addedCompetitor: "Added to Competitors",
    btnPortfolio: "+ My products",
    btnCompetitors: "+ Competitors",
    short_portfolio: "Mine",
    short_competitor: "Comp.",
    bulkIntro: "{n} products match this filter.",
    bulkToPortfolio: "Add all to My products",
    bulkToCompetitors: "Add all to Competitors",
    bulkNote: "Marketed ones only; those already added are skipped.",
    bulkAddedPortfolio: "{n} added to My products ({skipped} were already there).",
    bulkAddedCompetitors: "{n} added to Competitors ({skipped} were already there).",
    bulkParallel: "{n} are parallel imports and stay in Competitors until you decide.",
    addError: "Could not add",
    parallelImport: "Parallel import",
    parallelImportIp: "Parallel import: registration number {nreg} has the IP suffix. A third party markets it; it counts as a competitor unless you declare it your own.",
    parallelImportForeign: "Authorised in another EU country (registration number {nreg}). A third party markets it; it counts as a competitor unless you declare it your own.",
    addedAsParallelImport: "It is a parallel import: it stays in Competitors until you decide in My products",
  },
};
